import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFolderOpen,
  faDatabase,
  faLayerGroup,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";

const ProcessifydDashboard = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };
  
  const [activeTab, setActiveTab] = useState("example"); // example | my
  const [activeMenu, setActiveMenu] = useState("Process Master");

  const exampleProcesses = [
    "CSAT (Customer Satisfaction Process)",
    "Logistics",
    "Compliance & Audit Management",
    "CRM (Customer Relationship Management)",
    "Employee Onboarding",
    "Quality Management",
    "Lead Management",
    "Salary Processing",
    "KYC Documentation",
    "Campaign Management",
    "Appraisal Process",
    "Enrolment / Admission Management",
    "OMS (Order Management System)",
    "Bill Receivable",
    "Patient Treatment",
    "Seller Onboarding Management",
    "Bill Payable",
    "Agreement Management",
    "Product Launch",
    "Debt Approval",
    "Litigation Management",
    "Innovation Management",
    "Account Settlement",
    "LOS (Loan Origination System)",
    "Discovery Management",
    "Document Management",
    "Single Source of Truth Verification",
    "Manufacturing",
    "Content Management",
    "Customised Any Work Management",
  ];

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">Processifyd</div>
          <div className="text-[11px] text-gray-200">Process Center!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}
      <div className="min-h-screen bg-black text-wrap [&_p]:text-white flex flex-col">
        <div className="bg-purple-700 text-white p-3 flex justify-between items-center">
          <h1 className="text-sm md:text-lg font-semibold">
            TeamOB - Process & Work Center
          </h1>
          <div className="text-right text-xs md:text-sm">
            <p>Arun Kumar Singh</p>
            <p className="opacity-80">Chief Executive Officer</p>
          </div>
        </div>

        {/* MAIN */}
        <div className="flex flex-1 overflow-hidden">

          {/* LEFT SIDEBAR */}
          <div className="w-64 bg-black text-white border-r overflow-y-auto hidden md:block">
            <div className="p-3 font-semibold text-cyan-400 text-sm">
              Select My Screen
            </div>

            <div className="px-3 text-sm text-gray-100">
              <p className="font-semibold mt-2">- Master Record Management</p>

              {[
                "Process Master",
                "State Master",
                "State Transition Master",
                "Variables Master",
                "RACI Group Master",
                "RACI Person Mapping",
                "Reference Docs",
                "Script Master",
                "Group Master",
                "Users Master",
                "Clients Master",
                "Platform Help Text Master",
                "Platform Error Message Master",
                "Screen Master",
                "Command Master",
                "Role Master",
              ].map((item) => (
                <div
                  key={item}
                  onClick={() => setActiveMenu(item)}
                  className={`cursor-pointer px-2 py-1 rounded mt-1 ${
                    activeMenu === item
                      ? "bg-blue-800 text-white font-semibold"
                      : "hover:bg-blue-700"
                  }`}
                >
                  {item}
                </div>
              ))}

              <p className="font-semibold mt-4">- Mapping Table Management</p>
              <p className="mt-2">Process & Groups Mapping</p>
              <p>State & Groups Mapping</p>
              <p>State & Variables Mapping</p>
              <p>Command & Screen Mapping</p>
              <p>User & Role Mapping</p>
              <p>Role & Screen Mapping</p>
              <p>Role & Screen-Command Mapping</p>

              <p className="font-semibold mt-4 text-blue-700">
                Super Data Management
              </p>
              <p className="font-semibold text-blue-700">
                Import-Export Management
              </p>
              <p className="font-semibold text-blue-700">
                Settings & Configurations
              </p>
            </div>
          </div>

          {/* RIGHT PANEL */}
          <div className="flex-1 p-3 overflow-y-auto">

            {/* BREADCRUMB */}
            <div className="text-sm text-gray-600 mb-2">
              Home &gt;&gt; Select My Screen
            </div>

            {/* TOP TABS */}
            <div className="flex flex-col md:flex-row gap-2 mb-4">
              <button
                onClick={() => setActiveTab("example")}
                className={`flex-1 py-2 text-sm font-semibold rounded ${
                  activeTab === "example"
                    ? "bg-blue-900 text-white"
                    : "bg-gray-700 text-white"
                }`}
              >
                Load Example Process Center
              </button>

              <button
                onClick={() => setActiveTab("my")}
                className={`flex-1 py-2 text-sm font-semibold rounded ${
                  activeTab === "my"
                    ? "bg-blue-900 text-white"
                    : "bg-gray-700 text-white"
                }`}
              >
                My Processes
              </button>
            </div>

            {/* CONTENT */}
            {activeTab === "example" ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                {exampleProcesses.map((process, index) => (
                  <button
                    key={index}
                    className={`border px-3 py-2 text-sm rounded text-left ${
                      index % 2 === 0
                        ? "bg-green-700"
                        : "bg-blue-600"
                    } hover:bg-blue-500`}
                  >
                    {process}
                  </button>
                ))}
              </div>
            ) : (
              <div className="text-center py-20 text-gray-500">
                <FontAwesomeIcon icon={faDatabase} className="text-3xl mb-3" />
                <p>My Processes will load from DB</p>
              </div>
            )}

            {/* FOOTER PAGINATION */}
            <div className="flex justify-center items-center mt-6 gap-4">
              <button className="text-gray-400 text-sm">&lt;&lt; Prev</button>
              <div className="bg-purple-700 text-white px-4 py-1 text-sm rounded">
                Page 1/1
              </div>
              <button className="text-gray-400 text-sm">Next &gt;&gt;</button>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProcessifydDashboard;